// extracted by mini-css-extract-plugin
export var quoteBlockContainerClass = "LeftImageWithText-module--quoteBlockContainerClass--ybnYi";
export var quoteClass = "LeftImageWithText-module--quoteClass--4KsOM";
export var smallImageClass = "LeftImageWithText-module--smallImageClass--dX0jH";
export var smallRowClass = "LeftImageWithText-module--smallRowClass--cmHbO";
export var boxLinkClass = "LeftImageWithText-module--boxLinkClass--QaruG";